export const FORM_DEFS = {
  client_profile: {
    sections: [
      {
        title: "Client Information",
        fields: [
          { key: "full_name", label: "Client Name", type: "text" },
          { key: "dob", label: "Date of Birth", type: "date" },
          { key: "age", label: "Age", type: "text" },
          { key: "gender", label: "Gender", type: "radio", options: ["Female", "Male", "Other"] },
        ],
      },
      {
        title: "Contact Information",
        fields: [
          { key: "primary_phone", label: "Primary Phone", type: "text" },
          { key: "leave_message", label: "OK to leave a message?", type: "radio", options: ["Yes", "No"] },
          { key: "cell_phone", label: "Cell Phone", type: "text" },
          { key: "can_text", label: "Can text?", type: "radio", options: ["Yes", "No"] },
          { key: "email_addr", label: "Email Address", type: "text" },
          { key: "can_email", label: "Can email?", type: "radio", options: ["Yes", "No"] },
        ],
      },
      {
        title: "Service Address",
        fields: [
          { key: "street", label: "Street Address", type: "text" },
          { key: "city", label: "City", type: "text" },
          { key: "state", label: "State", type: "text" },
          { key: "zip", label: "ZIP", type: "text" },
          { key: "township", label: "Township", type: "text" },
          { key: "county", label: "County", type: "text" },
        ],
      },
      {
        title: "Primary Contact",
        fields: [
          { key: "pc_is_client", label: "Who is the primary contact?", type: "radio", options: ["Client", "Other"] },
          { key: "pc_name", label: "Full Name", type: "text" },
          { key: "pc_relationship", label: "Relationship", type: "text" },
          { key: "pc_phone", label: "Phone", type: "text" },
          { key: "pc_email", label: "Email", type: "text" },
        ],
      },
      {
        title: "Emergency Contact",
        fields: [
          { key: "ec_name", label: "Full Name", type: "text" },
          { key: "ec_relationship", label: "Relationship", type: "text" },
          { key: "ec_phone", label: "Phone", type: "text" },
          { key: "ec_email", label: "Email", type: "text" },
        ],
      },
      {
        title: "Medical Providers (for coordination only)",
        fields: [
          { key: "doctor_name", label: "Primary Doctor", type: "text" },
          { key: "doctor_phone", label: "Doctor Phone", type: "text" },
          { key: "sn_name", label: "Skilled Nursing", type: "text" },
          { key: "sn_phone", label: "SN Phone", type: "text" },
          { key: "wound_name", label: "Wound Care", type: "text" },
          { key: "wound_phone", label: "Wound Care Phone", type: "text" },
          { key: "hospice_name", label: "Hospice", type: "text" },
          { key: "hospice_phone", label: "Hospice Phone", type: "text" },
          { key: "pharmacy_name", label: "Pharmacy", type: "text" },
          { key: "pharmacy_phone", label: "Pharmacy Phone", type: "text" },
        ],
      },
      {
        title: "Home Information",
        fields: [
          { key: "home_type", label: "Home Type", type: "radio", options: ["Single Family", "Apartment", "Senior Housing", "Other"] },
          { key: "lives_alone", label: "Lives alone?", type: "radio", options: ["Yes", "No"] },
          { key: "lives_with", label: "If not, who lives with them?", type: "text" },
          { key: "floor_level", label: "Floor Level", type: "radio", options: ["First Floor", "Second Floor", "Other"] },
          { key: "entry", label: "Entry Instructions", type: "checks", options: ["Knock", "Buzzer / Doorbell", "Intercom / Call Box", "Lockbox"] },
          { key: "lockbox_code", label: "Lockbox Code", type: "text" },
          { key: "parking", label: "Where do we park?", type: "checks", options: ["Driveway", "On Street", "Parking Garage", "None Available"] },
          { key: "pets", label: "Pets in the home?", type: "radio", options: ["Yes", "No"] },
          { key: "pet_details", label: "Pet Details (type, name, temperament)", type: "textarea" },
          { key: "smoking", label: "Does anyone smoke inside?", type: "radio", options: ["Yes", "No"] },
        ],
      },
      {
        title: "Payment & Insurance",
        fields: [
          { key: "payment_source", label: "Payment Source", type: "radio", options: ["CHC", "Veterans", "Private Pay", "LTC Insurance", "Other"] },
          { key: "mco_name", label: "MCO Name", type: "text" },
          { key: "mco_member_id", label: "MCO Member ID", type: "text" },
          { key: "service_coordinator", label: "Service Coordinator", type: "text" },
          { key: "coordinator_phone", label: "Coordinator Phone", type: "text" },
          { key: "medicaid_id", label: "Medicaid ID", type: "text" },
          { key: "medicare_id", label: "Medicare ID", type: "text" },
          { key: "primary_insurance", label: "Primary Insurance", type: "text" },
          { key: "member_id", label: "Member ID", type: "text" },
        ],
      },
    ],
  },
  service_agreement: {
    sections: [
      {
        title: "Parties & Effective Date",
        fields: [
          { key: "effective_date", label: "Effective Date", type: "date" },
          { key: "client_name", label: "Client's Full Name", type: "text" },
          { key: "client_address", label: "Client's Full Address", type: "text" },
          { key: "authorized_person", label: "Authorized Person for Care Decisions", type: "text" },
          { key: "rep_type", label: "Type (Power of Attorney / Legal Representative)", type: "text" },
          { key: "emergency_phone", label: "Emergency Contact Phone", type: "text" },
          { key: "client_email", label: "Email", type: "text" },
        ],
      },
      {
        title: "Home Care Services Required",
        fields: [
          { key: "services", label: "Services", type: "checks", options: ["Personal Assistance Services (CHC)", "Home Care Assistance (Veteran's Benefit)", "Personal Care (Private)", "Long Term Care Services (LTC Insurance)", "Companionship (Private)", "Housekeeping (Private)", "Transportation (Private)"] },
          { key: "services_notes", label: "Notes", type: "textarea" },
        ],
      },
      {
        title: "Preferred Schedule & Caregivers",
        fields: [
          { key: "start_date", label: "Start Date", type: "date" },
          { key: "shift1_days", label: "Shift 1 — Days", type: "text" },
          { key: "shift1_time", label: "Shift 1 — Time", type: "text" },
          { key: "shift1_caregiver", label: "Shift 1 — Assigned Caregiver (if known)", type: "text" },
          { key: "shift2_days", label: "Shift 2 — Days", type: "text" },
          { key: "shift2_time", label: "Shift 2 — Time", type: "text" },
          { key: "shift2_caregiver", label: "Shift 2 — Assigned Caregiver", type: "text" },
          { key: "shift3_days", label: "Shift 3 — Days", type: "text" },
          { key: "shift3_time", label: "Shift 3 — Time", type: "text" },
          { key: "shift3_caregiver", label: "Shift 3 — Assigned Caregiver", type: "text" },
        ],
      },
      {
        title: "Rates & Payment",
        fields: [
          { key: "rate", label: "Rate for Service ($)", type: "text" },
          { key: "rate_type", label: "Rate Type", type: "radio", options: ["Per Visit", "Hourly", "Weekly"] },
          { key: "payment_method", label: "Payment Option", type: "radio", options: ["Check by Mail", "Cash App", "Venmo", "Credit Card"] },
          { key: "autopay", label: "Autopay Enrollment", type: "radio", options: ["Yes", "No"] },
        ],
      },
      {
        title: "Initials (per agreement clauses)",
        fields: [
          { key: "init_rights", label: "Client Rights & Preferences", type: "initials" },
          { key: "init_transportation", label: "Transportation Liability Release", type: "initials" },
          { key: "init_private_hire", label: "Private/Direct Hiring Prohibition", type: "initials" },
          { key: "init_termination", label: "Termination by Agency", type: "initials" },
        ],
      },
      {
        title: "Documents Received",
        fields: [
          { key: "received_docs", label: "Client acknowledges receipt of", type: "checks", options: ["Welcome Letter", "Client Rights and Responsibilities", "HIPAA Notice of Privacy Practices", "PA State Regulatory – Financial Addendum", "Direct Care Worker Status Notification", "Silver Home Care Client Handbook", "Complaint Resolution & External Reporting Resources", "DCW Selection, Competency & Training Requirements", "Scheduling Policies & Procedures", "Emergency & After-Hours Contact Information", "Policies on Termination of Services", "Home Surveillance Policy", "Mandated Reporting of Abuse, Neglect & Exploitation", "Advance Care Planning"] },
        ],
      },
    ],
  },
  home_safety: {
    sections: [
      {
        title: "Visit Details",
        fields: [
          { key: "insp_name", label: "Inspection Completed By", type: "text" },
          { key: "insp_date", label: "Inspection Date", type: "date" },
          { key: "living", label: "Current Living Arrangement", type: "checks", options: ["Private home", "Apartment", "Condo", "Room in care facility", "Married", "Lives with spouse/family/friend", "Lives alone"] },
        ],
      },
      { title: "General Area of Home", fields: [{ key: "area_general", label: "Check all that apply", type: "checks", options: ["Traffic areas free of clutter & furniture", "Cords secured and out of walkways", "Rugs are non-slip or removed", "Lighting is adequate throughout", "Pathways between rooms are clear"] }] },
      { title: "Alarms & Security", fields: [{ key: "area_alarms", label: "Check all that apply", type: "checks", options: ["Smoke detectors work", "Carbon monoxide detector works", "Fire extinguisher accessible", "Emergency numbers posted", "Door locks work properly"] }] },
      { title: "Kitchen", fields: [{ key: "area_kitchen", label: "Check all that apply", type: "checks", options: ["Oven & burners all work", "No flammables near stove", "Food stored safely / not expired", "Frequently used items within reach", "Floor is dry and non-slip"] }] },
      { title: "Stairs", fields: [{ key: "area_stairs", label: "Check all that apply", type: "checks", options: ["Handrails on both sides secure", "Steps in good repair", "Adequate lighting", "Free of clutter"] }] },
      { title: "Bathrooms", fields: [{ key: "area_bathrooms", label: "Check all that apply", type: "checks", options: ["Grab bars secure", "All personal care items within reach", "Non-slip mat in tub/shower", "Toilet height adequate", "Water temperature safe"] }] },
      { title: "Outdoor Maintenance", fields: [{ key: "area_outdoor", label: "Check all that apply", type: "checks", options: ["Walkways clear and in good repair", "Services to maintain grounds (all seasons)", "Entry lighting works"] }] },
      { title: "Bedrooms", fields: [{ key: "area_bedrooms", label: "Check all that apply", type: "checks", options: ["Rooms are brightly lit", "Path to bathroom is clear", "Phone within reach of bed", "Nightlights present"] }] },
      { title: "Garage (if applicable)", fields: [{ key: "area_garage", label: "Check all that apply", type: "checks", options: ["Organized", "Hazards stored safely"] }] },
    ],
  },
  dcw_role_confirmation: {
    sections: [
      {
        title: "People Covered",
        fields: [
          { key: "client_name", label: "Client Name", type: "text" },
          { key: "dcw_name", label: "Direct Care Worker Name", type: "text" },
          { key: "relationship", label: "Relationship to Client (if any)", type: "text" },
          { key: "review_date", label: "Review Date", type: "date" },
        ],
      },
      {
        title: "Confirmation",
        fields: [
          { key: "confirmation", label: "Confirmation", type: "radio", options: ["Confirmed — the DCW is not the POA, authorized/legal representative, designated payee, or representative payee", "Do not sign — contact the office"] },
          { key: "notes", label: "Notes / follow-up needed", type: "textarea" },
        ],
      },
      {
        title: "Office Verification",
        fields: [
          { key: "verified_by", label: "Verified By", type: "text" },
          { key: "verification_date", label: "Verification Date", type: "date" },
        ],
      },
    ],
  },
  medication_list: { meds: true, sections: [] },
  service_information_handout: {
    sections: [
      {
        title: "Service Information",
        fields: [
          { key: "client_name", label: "Client name", type: "text" },
          { key: "start_date", label: "Start date", type: "date" },
          { key: "shift1_days", label: "Days", type: "text" },
          { key: "shift1_time", label: "Times", type: "text" },
          { key: "shift1_caregiver", label: "Caregiver (if known)", type: "text" },
          { key: "services_notes", label: "Services requested", type: "textarea" },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  dc_addendum: {
    sections: [
      {
        title: "People Covered",
        fields: [
          { key: "client_name", label: "Client (participant) name", type: "text" },
          { key: "caregiver_name", label: "Designated caregiver name", type: "text" },
        ],
      },
      {
        title: "Confirmation",
        fields: [
          { key: "confirmation", label: "Confirmation", type: "radio", options: ["Confirmed — this caregiver is not my spouse, Power of Attorney, legal guardian, or representative payee", "Do not sign — contact the office"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  dc_attestation: {
    sections: [
      {
        title: "People Covered",
        fields: [
          { key: "employee_name", label: "Caregiver name", type: "text" },
          { key: "client_name", label: "Client (participant) name", type: "text" },
          { key: "relationship", label: "Relationship to the client", type: "text" },
        ],
      },
      {
        title: "Attestation",
        fields: [
          { key: "certify", label: "Attestation", type: "radio", options: ["I certify that I am not this participant's spouse, Power of Attorney, legal guardian, or representative payee", "Do not sign — contact the office"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  dc_employment_ack: {
    sections: [
      {
        title: "People Covered",
        fields: [
          { key: "employee_name", label: "Employee (caregiver) name", type: "text" },
          { key: "client_name", label: "Designated client name", type: "text" },
        ],
      },
      {
        title: "Acknowledgment",
        fields: [
          { key: "ack", label: "Check all that apply", type: "checks", options: ["Same trainings, EVV, and policies as every other employee", "Paid scheduled shifts only", "My responsibility doesn't end with the shift", "I will tell the office when anything changes"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  medicaid_fraud_notice: {
    sections: [
      {
        title: "People Covered",
        fields: [
          { key: "client_name", label: "Client (participant) name", type: "text" },
          { key: "caregiver_name", label: "Caregiver name", type: "text" },
        ],
      },
      {
        title: "Acknowledgment",
        fields: [
          { key: "signing_as", label: "Who is signing this copy?", type: "radio", options: ["Client / representative", "Caregiver"] },
          { key: "ack", label: "Acknowledgment", type: "radio", options: ["We have read this page and understand what fraud, waste, and abuse look like", "Do not sign — contact the office"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  references_form: {
    sections: [
      {
        title: "Applicant",
        fields: [
          { key: "applicant_name", label: "Applicant name", type: "text" },
          { key: "position", label: "Position applied for", type: "text" },
        ],
      },
      {
        title: "Personal Reference 1",
        fields: [
          { key: "ref1_name", label: "Name", type: "text" },
          { key: "ref1_phone", label: "Phone", type: "text" },
          { key: "ref1_relationship", label: "Relationship (not a relative)", type: "text" },
          { key: "ref1_years", label: "Years known (1+ required)", type: "text" },
        ],
      },
      {
        title: "Personal Reference 2",
        fields: [
          { key: "ref2_name", label: "Name", type: "text" },
          { key: "ref2_phone", label: "Phone", type: "text" },
          { key: "ref2_relationship", label: "Relationship (not a relative)", type: "text" },
          { key: "ref2_years", label: "Years known (1+ required)", type: "text" },
        ],
      },
      {
        title: "Personal Reference 3",
        fields: [
          { key: "ref3_name", label: "Name", type: "text" },
          { key: "ref3_phone", label: "Phone", type: "text" },
          { key: "ref3_relationship", label: "Relationship (not a relative)", type: "text" },
          { key: "ref3_years", label: "Years known (1+ required)", type: "text" },
        ],
      },
      {
        title: "Professional Reference 1",
        fields: [
          { key: "prof1_company", label: "Company / organization", type: "text" },
          { key: "prof1_contact", label: "Contact name", type: "text" },
          { key: "prof1_phone", label: "Phone", type: "text" },
        ],
      },
      {
        title: "Professional Reference 2",
        fields: [
          { key: "prof2_company", label: "Company / organization", type: "text" },
          { key: "prof2_contact", label: "Contact name", type: "text" },
          { key: "prof2_phone", label: "Phone", type: "text" },
        ],
      },
      {
        title: "Authorization",
        fields: [
          { key: "authorize", label: "Authorization", type: "radio", options: ["I authorize Silver Home Care to contact these references", "Do not sign"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  drug_testing_consent: {
    sections: [
      {
        title: "Consent",
        fields: [
          { key: "applicant_name", label: "Applicant name", type: "text" },
          { key: "position", label: "Position applied for", type: "text" },
          { key: "consent", label: "Consent", type: "radio", options: ["I consent to drug testing as described in this form", "Do not sign"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  interview_form: {
    sections: [
      {
        title: "Candidate",
        fields: [
          { key: "candidate", label: "Candidate", type: "text" },
          { key: "employee_id", label: "Employee ID", type: "text" },
          { key: "interview_date", label: "Interview date", type: "date" },
          { key: "interviewed_by", label: "Interviewed by", type: "text" },
        ],
      },
      { title: "ID Verification", fields: [{ key: "id_checks", label: "Check all that apply", type: "checks", options: ["ID number visually verified", "Date of birth visually verified", "SSN visually verified"] }] },
      {
        title: "Observation",
        fields: [
          { key: "observation", label: "Check all that apply", type: "checks", options: ["Candidate on time", "Dressed appropriately / good hygiene", "Demeanor appropriate and engaged", "Previous experience", "Answered questions satisfactorily"] },
          { key: "notes", label: "Interview notes", type: "textarea" },
        ],
      },
      {
        title: "Determination",
        fields: [
          { key: "provisional", label: "Provisional hire?", type: "radio", options: ["Yes", "No"] },
          { key: "proceed", label: "Proceed to hire?", type: "radio", options: ["Yes", "No", "Deferred"] },
          { key: "reason", label: "Reason (if no/deferred)", type: "text" },
          { key: "hire_date", label: "Date of hire", type: "date" },
        ],
      },
    ],
  },
  tb_form: {
    sections: [
      {
        title: "Employee",
        fields: [
          { key: "employee", label: "Employee", type: "text" },
          { key: "employee_id", label: "Employee ID", type: "text" },
          { key: "hire_date", label: "Hire date", type: "date" },
          { key: "screening_date", label: "Screening date", type: "date" },
          { key: "dob", label: "Date of birth", type: "date" },
          { key: "screening_type", label: "Screening type", type: "radio", options: ["Baseline — two-step intradermal (Mantoux)", "Annual screening"] },
        ],
      },
      {
        title: "Step 1 — intradermal test",
        fields: [
          { key: "step1_placed", label: "Date placed", type: "date" },
          { key: "step1_read", label: "Date read (48-72 hrs)", type: "date" },
          { key: "step1_result", label: "Result", type: "radio", options: ["Negative", "Positive"] },
          { key: "step1_mm", label: "mm induration", type: "text" },
        ],
      },
      {
        title: "Step 2 — baseline only (1-3 weeks after step 1)",
        fields: [
          { key: "step2_placed", label: "Date placed", type: "date" },
          { key: "step2_read", label: "Date read (48-72 hrs)", type: "date" },
          { key: "step2_result", label: "Result", type: "radio", options: ["Negative", "Positive"] },
          { key: "step2_mm", label: "mm induration", type: "text" },
        ],
      },
      {
        title: "History & Symptoms",
        fields: [
          { key: "prior_positive", label: "History of a positive TB test?", type: "radio", options: ["No", "Yes"] },
          { key: "cxr", label: "Chest X-ray date & result", type: "text" },
          { key: "symptoms", label: "Symptom review", type: "checks", options: ["Cough lasting more than 3 weeks", "Coughing up blood", "Unexplained weight loss", "Night sweats", "Fever or chills", "Unusual fatigue", "None"] },
        ],
      },
      {
        title: "Determination",
        fields: [
          { key: "cleared", label: "Cleared for duty?", type: "radio", options: ["Yes", "No"] },
          { key: "restrictions", label: "Restrictions / follow-up", type: "text" },
          { key: "next_due", label: "Next screening due (annual)", type: "date" },
          { key: "administered_by", label: "Administered / read by", type: "text" },
        ],
      },
    ],
  },
  ob_skills_checklist: {
    sections: [
      {
        title: "Experience",
        fields: [
          { key: "employee_name", label: "Employee name", type: "text" },
          { key: "experience", label: "Care situations you have experience with", type: "checks", options: ["Hospice / end-of-life care", "Diabetes (meal support and care)", "Mental illness", "Developmental disabilities", "CVA/Stroke recovery", "Brain injuries", "Multiple sclerosis", "Parkinson's disease", "Paraplegia/Quadriplegia", "Blindness or visual impairment", "Fall-risk or mobility-impaired clients", "Giving a bed bath", "Performing peri-care", "Performing mouth care", "Shaving with an electric shaver (no razors)", "Hair care", "Dressing upper/lower body", "Toileting", "Incontinence and adult diapers", "Giving a bed pan", "Emptying a commode", "Performing bedside care", "Mobility & safe transfers", "Repositioning"] },
          { key: "other_experience", label: "Other experience", type: "textarea" },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  ob_background_authorization: {
    sections: [
      {
        title: "Demographics",
        fields: [
          { key: "full_name", label: "Full name", type: "text" },
          { key: "birth_date", label: "Birth Date", type: "date" },
          { key: "address", label: "Address", type: "text" },
          { key: "ssn", label: "Social Security Number", type: "text" },
        ],
      },
      {
        title: "Driver's License",
        fields: [
          { key: "dl_number", label: "Driver's License Number", type: "text" },
          { key: "dl_state", label: "State of Issue", type: "text" },
          { key: "dl_issue", label: "Date of Issue", type: "date" },
          { key: "dl_exp", label: "Expiration Date", type: "date" },
        ],
      },
      {
        title: "Authorization",
        fields: [
          { key: "checks", label: "Checks authorized", type: "checks", options: ["Criminal Background", "Employment Verification", "Education Verification", "Child Abuse check", "Motor Vehicle Records", "Reference Verification", "Drug Screening", "Sexual Offender Registry Check"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  ob_criminal_history: {
    sections: [
      {
        title: "Attestation",
        fields: [
          { key: "full_name", label: "Full name", type: "text" },
          { key: "has_offense", label: "Criminal history", type: "radio", options: ["No convictions to report", "Conviction(s) listed below"] },
          { key: "offense", label: "Nature of the offense, date of conviction, jurisdiction, sentence, current status", type: "textarea" },
          { key: "sign_date", label: "Today's Date", type: "date" },
        ],
      },
    ],
  },
  ob_emergency_contact: {
    sections: [
      {
        title: "Emergency Contact",
        fields: [
          { key: "employee_name", label: "Employee name", type: "text" },
          { key: "ec_name", label: "Emergency Contact Name", type: "text" },
          { key: "ec_email", label: "Emergency Contact Email", type: "text" },
          { key: "ec_phone", label: "Emergency Contact Primary Phone", type: "text" },
          { key: "ec_phone2", label: "Emergency Contact Secondary Phone", type: "text" },
          { key: "ec_address", label: "Emergency Contact Address", type: "text" },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  ob_on_demand_pay: {
    sections: [
      {
        title: "Election",
        fields: [
          { key: "employee_name", label: "Employee name", type: "text" },
          { key: "election", label: "Preference", type: "radio", options: ["Enroll in On-Demand Pay", "Standard pay schedule only"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
  ob_tb_screening: {
    sections: [
      {
        title: "Symptom Review",
        fields: [
          { key: "employee_name", label: "Employee name", type: "text" },
          { key: "symptoms", label: "Check all that apply", type: "checks", options: ["Persistent cough", "Persistent fever/chills/night sweats", "Coughing up blood", "Tiring easily or loss of appetite", "Weight loss without dieting", "Chest pains or shortness of breath", "Exposure to Tuberculosis", "NONE OF THE ABOVE"] },
          { key: "sign_date", label: "Date", type: "date" },
        ],
      },
    ],
  },
};
